import React from 'react';
import './Registrar.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';

const Registrar = () => {
  return (
    <div className="registrar-page">
      <Navbar />
      
      <div id="registrar-container">
        <div id="registrar-page-header">
          <h1>The Registrar</h1>
        <p className="registrar-subtitle">
            Rayalaseema University
          </p>
          <div id="registrar-header-underline"></div>
        </div>
        
        <div id="registrar-main-profile">
          <div id="registrar-image">
            <img src="/person/registrar-Vijay.JPG" alt="Dr. B. Vijaya Kumar Naidu " />
          </div>
          
          <div id="registrar-details">
            <h2>Prof. B. Vijaya Kumar Naidu</h2>
            <p id="registrar-title">Registrar, Rayalaseema University</p>
            
            <div id="registrar-info">
              <p><strong>Qualification:</strong> Ph.D. (2002) - Polymer Science & Technology, Sri Krishnadevaraya University, Anantapur</p>
              <p><strong>Current Position:</strong> Associate Professor & Head, Department of Materials Science & Nanotechnology, Yogi Vemana University, Kadapa</p>
            </div>
          </div>
        </div>

        <div id="registrar-content">
          <div className="registrar-section">
            <h3>Teaching Experience</h3>
            <div className="registrar-career-list">
              <p><strong>July 2021 - Present:</strong> Associate Professor, Department of Materials Science & Nanotechnology, Yogi Vemana University, Kadapa</p>
              <p><strong>July 2009 - July 2021:</strong> Assistant Professor, Department of Materials Science & Nanotechnology, Yogi Vemana University, Kadapa</p>
            </div>
          </div>

          <div className="registrar-section">
            <h3>Postdoctoral Experience</h3>
            <div className="registrar-career-list">
              <p><strong>Feb 2015 - Feb 2016:</strong> UGC Raman Postdoctoral Fellow at UTHSC, Memphis, USA</p>
              <p><strong>Aug 2007 - July 2009:</strong> Postdoctoral Fellow, Dalhousie University, Canada</p>
              <p><strong>May 2005 - Apr 2007:</strong> Postdoctoral Fellow, Pusan National University, South Korea</p>
              <p><strong>Mar 2003 - Apr 2005:</strong> Research Associate, Karntak University, Dharwad, India</p>
            </div>
          </div>

          <div className="registrar-section">
            <h3>Administrative Experience at Yogi Vemana University</h3>
            <ul>
              <li><strong>December 2022 - Present:</strong> Head, Department of Materials Science and Nanotechnology</li>
              <li><strong>March 2022 - Present:</strong> Chairman, Board of Studies, Dept of Materials Science and Nanotechnology</li>
              <li><strong>September 2020 - Present:</strong> Coordinator, College Development Council</li>
              <li><strong>October 2017 - Present:</strong> Coordinator, RUSA</li>
              <li>Coordinator, Transport Section</li>
              <li>Associate Director, Directorate of Admissions</li>
              <li>Core Committee Member for SSR Preparation of NAAC 1st Cycle</li>
              <li>Member, Central Purchase Committee</li>
              <li>Coordinator, Department of Materials Science and Nanotechnology</li>
            </ul>
          </div>

          <div className="registrar-section">
            <h3>Research Projects</h3>
            <ul>
              <li><strong>DST Project (2011-2014):</strong> Hydrophilic-hydrophobic based polymeric membranes for pervaporation separation applications - ₹17.63 Lakhs</li>
              <li><strong>UGC Project (2013-2016):</strong> Nanostructured TiO₂ Incorporated Polymer Nanocomposite Membranes for Pervaporation Separation Applications - ₹9.63 Lakhs</li>
            </ul>
          </div>

          <div className="registrar-section">
            <h3>Achievements & Awards</h3>
            <div className="registrar-stats">
              <span><strong>2</strong> Major Awards</span>
              <span><strong>66</strong> Research Publications</span>
              <span><strong>3</strong> Ph.D. Awarded</span>
            </div>
            <ul>
              <li><strong>April 2014:</strong> UGC-Raman Postdoctoral Fellowship (to work in USA for 1 year)</li>
              <li><strong>March 2011:</strong> DST Young Scientist Award</li>
            </ul>
          </div>

          <div className="registrar-section">
            <h3>Ph.D. Guidance</h3>
            <p><strong>Ph.D. Awarded: 3</strong></p>
            <ul>
              <li><strong>S. Siva Sankar (Dec 2016):</strong> Development of different polymer system for drug delivery and separation applications</li>
              <li><strong>B. Venkataramana (Jan 2019):</strong> Development of metal/metal oxide nanoparticles for biomedical applications</li>
              <li><strong>Sai Kumar (Aug 2020):</strong> Development of Carbon based nanostructures/TiO₂ based DSSCs for Improved Efficiency</li>
            </ul>
            
            <p><strong>Ph.D. Pursuing: 5</strong></p>
            <ul>
              <li>B. Sunkanna - Development of polymer based matrices for separation applications (Part-Time)</li>
              <li>G. Hussian Reddy - Natural product mediated synthesis of metallic nanoparticles and evaluation of their biological/catalytic applications (Part-Time)</li>
              <li>M. Suvarna - Development of polymer based nanocomposite embed zeolites systems for environmental applications (Part-Time)</li>
              <li>N. Nanda Kishore - Development of polymer based films for packaging applications (Part-Time)</li>
              <li>M. Jyothi - XWO₄ (X= Zn, Ni, Ti)/Carbon structures-based nanocomposites for DSSCs and Supercapacitor (Full-Time)</li>
            </ul>
          </div>

          <div className="registrar-section">
            <h3>Research Publications & Contributions</h3>
            <div className="registrar-stats">
              <span><strong>66</strong> SCI Journal Papers</span>
              <span><strong>3</strong> Book Chapters</span>
              <span><strong>1</strong> Patent (Korean)</span>
            </div>
            <ul>
              <li>Research Publications in National & International SCI Journals: 66</li>
              <li>Number of Book Chapters (National/International): 3</li>
              <li>Patents: 1 (Korean)</li>
              <li>Conferences/Symposia Organized: 1</li>
              <li>Conferences/Symposia Attended: 54</li>
            </ul>
          </div>

          <div className="registrar-section">
            <h3>Research Areas</h3>
            
            <h4>1. Polymer Based Carrier for Separation and Biomedical Applications</h4>
            <p>Development of various natural polymer matrices and their composites with metal and metal oxide in the form of films, micro and nanoparticles. These matrices are tested for:</p>
            <ul>
              <li>Separating aqueous azeotropic mixtures using membrane based pervaporation technique</li>
              <li>Drug delivery and bio-molecule carriers (beads, gels, and particles)</li>
              <li>Catalytic and antimicrobial activity testing</li>
            </ul>

            <h4>2. CNT Based Dye Sensitized Solar Cells</h4>
            <p>Development of CNT based photoanode materials for dye sensitized solar cells using:</p>
            <ul>
              <li>Ruthenium based dyes</li>
              <li>Various polymeric materials as contiguous phase</li>
              <li>Doctor blade method for film formation</li>
            </ul>
          </div>

          <div className="registrar-section">
            <h3>Professional Memberships & Services</h3>
            <ul>
              <li><strong>Life Member:</strong> Polymer Society of India, Madras Chapter</li>
              <li><strong>Journal Reviewer:</strong> Journal of Applied Polymer Science, Materials Letters, Inorganic and Nano Metal Chemistry, Journal of Chemical and Pharmaceutical Research</li>
              <li><strong>Ph.D. Thesis Adjudicator:</strong> Andhra University (Vishakhapatnam), Mysore University</li>
            </ul>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Registrar;